import { isEmpty } from '../isEmpty.js';
/**
 * Takes an object with an optional `layout` property and transforms it into the ThemePropertiesLayout object type.
 * @param {LayoutProperties} props - An object with an optional `layout` property.
 * @returns {ThemePropertiesLayout} An object with type ThemePropertiesLayout
 */
export function getLayoutOptions(layout) {
    if (!isEmpty(layout)) {
        return {
            layout,
        };
    }
    return {};
}
